export const projects = [
    {
      projectName: "Cloud Infrastructure for US & Europe customers",
      projectDescription:
        "Crypto offers secure digital wallet for everything.  \
        Pay friends, Get paid, Buy crypto currency or Just save up for a rainy day.  We were engaged as they are expanding services in Europe.  \
        It involves  discover current Kubernetes/Container Infrastructure, propose target architecture and  \
        build multi-region AWS Infrastructure, EKS and CI/CD with improved release process.",
      projectFullDescription : {
        textData: "Crypto offers secure digital wallet for everything.  \
        Pay friends, Get paid, Buy crypto currency or Just save up for a rainy day.  We were engaged as they are expanding services in Europe.  \
        It involves  discover current Kubernetes/Container Infrastructure, propose target architecture and  \
        build multi-region AWS Infrastructure, EKS and CI/CD with improved release process. \
        Delivered in 10 weeks. 2 weeks to discovery & planning, and 8 weeks to delivery with 2 Engineers, i.e., 80 Architecture and 640 Engineer hours.",
        textStyle: {
          color: "#808080",
          fontSize: "22px"
        },
      },
      technologiesHeadingStyle: {
        color: "#008000",
        fontSize: "20px"
      }, 
      skills: [
        {
          name: "EKS",
          description:
            "Multiple EKS clusters are build to isolate dev, qa and production environments in multiple regions. Configure \
            kustomize to parameterize Helm Charts for each environment and regions.",
          skillNameStyle: {
              color: "#00008B",
              fontSize: "20px"
            },
          skillDescriptionStyle: {
              color: "#008000",
              fontSize: "15px"
            },    
        },
        {
          name: "ArgoCD",
          description:
            "GitOps release process developed using ArgoCD. This simple process not only offers realiable code delivery, but protects againest human errors. Developed a branching \
             strategy for effective release and rollback.",
          skillNameStyle: {
              color: "#00008B",
              fontSize: "20px"
            },
          skillDescriptionStyle: {
              color: "#008000",
              fontSize: "15px"
            }, 
        },
        {
          name: "Transit Gatway",
          description:
            "Network Account is home for TransitGateway and Transit Gateway route-tables, which controls Layer3 traffic between specific regions, accounts and VPCs. \
            It is best alternative to VPC peeing, with multiple VPCs and still have control over traffic between VPCs ",
          skillNameStyle: {
              color: "#00008B",
              fontSize: "20px"
            },
          skillDescriptionStyle: {
                color: "#008000",
                fontSize: "15px"
            },   
        },
      ],
      images: [
        {
          img: require('./images/AWS_Multi_Region_Network.png'),
          title: "",
          featureDescription : {
            textData: "",
            textStyle: {
              color: "#000000",
              fontSize: "15px"
            },
          },
          featureHeading : {
            textData: "",
            textStyle: {
              color: "#000000",
              fontSize: "20px"
            },
          },
        },
        {
          img: require('./images/cta-11.png'),
          title: "",
          featureDescription : {
            textData: "We proposed multiple AWS accounts to isolate workloads, enforce zero trust policies.  For exmple, Dev Team needs full access to Development Account, \
            but readonly access to QA and limited access to production. SysOps team may have full access Development, QA and Production, but readonly to Network Account.  \
            Billing & Accounting team may have read access Centralized Billing in Main account. ",
            textStyle: {
              color: "#7F00FF",
              fontSize: "15px"
            },
          },
          featureHeading : {
            textData: "Zero Trust",
            textStyle: {
              color: "#008000",
              fontSize: "20px"
            },
          },
        },
        {
          img: require('./images/cta-13.png'),
          title: "",
          featureDescription : {
            textData: "GitLab is customer choice for SCM. We make sure docker images are getting scanned for known vulnerabilities \
            and best practices are followed to further ensure container security. Proposed ArgoCD as GitOps solution.  i.e., infrastructure \
            in sync with manifest/Helm in repos. Helm Chart and Kustomization are leveraged to parameterize Kubernetes manifest specific to environment and region.",
            textStyle: {
              color: "#7F00FF",
              fontSize: "15px"
            },
          },
          featureHeading : {
            textData: "Continue Integration and Deployment - GitOps Approach",
            textStyle: {
              color: "#008000",
              fontSize: "20px"
            },
          },
        },
        {
          img: require('./images/cta-14.png'),
          title: "",
          featureDescription : {
            textData: "TransitGateway enables connectivity between VPCs across AWS accounts, while Transitgateway peering connects TransitGateways across regions. \
            Cross region connectivity enabled Crypto to have Global Delivery systems, while ensuring GDPR complaints. \
            Delovelopment and QA in us-east-1 region, with code delivered to isolated production environments(usa and europe) using Kuberneretes GitOps tool.",
            textStyle: {
              color: "#7F00FF",
              fontSize: "15px"
            },
          },
          featureHeading : {
            textData: "AWS Infrastructure",
            textStyle: {
              color: "#008000",
              fontSize: "20px"
            },
          },
        },
      ],
    }
  ];